"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const createProNumberWithCheckDigitGetter = (strategy) => (params) => {
    const { proNumber, isProPreAssigned } = params;
    if (!proNumber) {
        return "";
    }
    const trimmedPro = proNumber.trim();
    if (!trimmedPro || !/^\d+$/.test(trimmedPro)) {
        return "";
    }
    return strategy.getProNumberWithCheckDigit({
        proNumber: trimmedPro,
        isProPreAssigned,
    });
};
exports.default = createProNumberWithCheckDigitGetter;
